module.exports = __webpack_public_path__ + "img/0.69e189a8.png";